import classnames from 'classnames/bind';
import React from 'react';
import styles from 'presentation/components/styles/__demo__/AnswerItem.css';
import PropTypes from 'prop-types';

let cx = classnames.bind(styles);

class AnswerItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    const AnswerItemPropTypes = {
      answerId: PropTypes.string,
      currentFocusIndex: PropTypes.number,
      focusIndex: PropTypes.number,
      isSearchedAnswer: PropTypes.bool.isRequired,
      name: PropTypes.string,
      onMouseDown: PropTypes.func.isRequired,
    };
    PropTypes.checkPropTypes(AnswerItemPropTypes, props, 'prop', 'AnswerItem');
    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleOnKeyPress = this.handleOnKeyPress.bind(this);
  }

  handleMouseDown() {
    this.props.onMouseDown(this.props.answerId);
  }

  //removing console errors. Need to actually implement this for ADA
  handleOnKeyPress() {}

  getClassNames() {
    return cx(
      this.props.isSearchedAnswer ? styles.answerItem_searched : styles.answerItem_suggested,
      this.props.currentFocusIndex === this.props.focusIndex && this.props.isSearchedAnswer
        ? styles.answerItem_selected
        : null
    );
  }

  render() {
    return (
      <div
        className={this.getClassNames()}
        role="button"
        tabIndex="0"
        onMouseDown={this.handleMouseDown}
        onKeyPress={this.handleOnKeyPress}
        onBlur={this.props.onBlur}
      >
        {this.props.name}
      </div>
    );
  }
}

export default AnswerItem;
